export const ESTUDIO_SIZE = 1080;
/** Imágenes al mes que paga Clientelo: GPT Image 2.5, calidad media. */
export const LIMITE_CORTESIA_IA = 200;

export type FondoId =
  | 'original'
  | 'transparente'
  | 'blanco'
  | 'negro'
  | 'gris'
  | 'navy'
  | 'azul'
  | 'beige'
  | 'atardecer'
  | 'bosque'
  | 'ciudad'
  | 'marmol'
  | 'madera'
  | 'bokeh'
  | 'estudio'
  | 'foto';

export interface PixelBuffer {
  width: number;
  height: number;
  data: Uint8ClampedArray;
}

export interface FondoPreset {
  id: FondoId;
  nombre: string;
  /** CSS background for the preset thumbnail */
  swatch: string;
  opaque: boolean;
}

export type EstudioLayerRole = 'producto' | 'persona';

export type EstudioActivoTipo = 'modelo' | 'fondo' | 'recorte';

export type TipoOfertaEstudio = 'producto' | 'servicio' | 'membresia' | 'listado';

export type EstudioProveedorIa = 'cortesia' | 'openai_propia' | 'gemini_propia' | 'chatgpt';

export interface LayerTransform {
  x: number;
  y: number;
  scale: number;
}

export interface PosePreset {
  id: string;
  nombre: string;
  producto: LayerTransform;
  modelo: LayerTransform;
}

export interface EstudioActivo {
  id: string;
  empresa_id: string;
  tipo: EstudioActivoTipo;
  nombre: string;
  imagen_url: string;
  created_at: string;
}

export interface EstudioLook {
  id: string;
  empresa_id: string;
  nombre: string;
  tipo_oferta: TipoOfertaEstudio | null;
  categoria_id: string | null;
  modelo_id: string | null;
  fondo_id: string | null;
  fondo_preset: FondoId;
  poses: PosePreset[];
  imagenes_por_color: number;
  notas: string | null;
  created_at: string;
}

export interface EstudioUsoIa {
  empresa_id: string;
  generaciones_cortesia: number;
  limite_cortesia: number;
  /** Mes vigente YYYY-MM (America/Bogota). Vacío en filas anteriores al cupo mensual. */
  periodo?: string | null;
}
